/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Moving_Time_Short_LabelInputs */

const en_exp_moving_time_short_label = /** @type {(inputs: Exp_Moving_Time_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving`)
};

const de_exp_moving_time_short_label = /** @type {(inputs: Exp_Moving_Time_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewegt`)
};

/**
* | output |
* | --- |
* | "Moving" |
*
* @param {Exp_Moving_Time_Short_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_moving_time_short_label = /** @type {((inputs?: Exp_Moving_Time_Short_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Moving_Time_Short_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_moving_time_short_label(inputs)
	return de_exp_moving_time_short_label(inputs)
});